module.exports = __webpack_public_path__ + "static/media/headache.aa695be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/headache.png
// module id = 405
// module chunks = 0